import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from '../services/login.service';
import { ModalComponent } from '../shared/dialog/modal/modal.component';
import { DialogService } from '../shared/services/dialog-service';
import { FunnelReportService } from '../shared/services/funnel-report.service';
import { HomeService } from '../shared/services/home.service';
import { ExcelService } from '../shared/services/export-excel/export-excel.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';

export class ReportType {
  name: String;
  type: number;
  key: string;
}

@Component({
  selector: 'app-funnel-report',
  templateUrl: './funnel-report.component.html',
  styleUrls: ['./funnel-report.component.scss']
})
export class FunnelReportComponent implements OnInit {

  public reportType: ReportType[];
  public reportCaption: string = '';
  public export: string = '';
  public filters = ['Age', 'City', 'Gender', 'SEC', 'UTM', 'Date'];
  public secFilter = ['A1', 'A2', 'A3', 'B1', 'B2', 'C1', 'C2', 'D1', 'D2', 'E1', 'E2', 'E3'];
  public selectedFilter: any = [];
  public allowedFilter:any = [];
  public todayDate: any;
  public minDate: any;
  public startDate: any;
  public endDate: any;
  public selectedType: string;
  public quota: any = [];
  public city: any = [];
  public utm: any = [];
  public gender: any = [];
  public sec: any = [];
  public age: any = { from: null, to: null };
  public dateRange: string;
  public studyId: string;
  public funnelReport: any;
  public isLoading: boolean = false;
  public isAction: boolean = false;
  public isData: boolean = false;
  public fixedMin: any;
  public headCounter: number = 0;
  public isMoreFilter: boolean = false;
  public sortBy: string = '';
  public isSortBy: boolean = false;
  public reportListFilter: any = [];
  public reportList: any = [];
  public isFilter: boolean = false;
  public groupBy: string = '';
  public groups = [];
  public access:any;
  public twoYearAgo:any;

  constructor(
    private homeService: HomeService,
    private activatedRoute: ActivatedRoute,
    public sanitization: DomSanitizer,
    private router: Router,
    private sidePanel:SidePanelService,
    private cookieService: CookieService,
    private dialogService: DialogService,
    private logerror: LoginService,
    private excelService: ExcelService,
    private dialog: MatDialog,
    private notifier: NotifierService,
    public funnelService: FunnelReportService) {
    this.access = JSON.parse(localStorage.getItem('access'));
    if(this.access && this.access.id &&  this.access.id == '63f1db1a-5222-11ee-ad29-42010aa00020'){
      this.sidePanel.isDemoUserWithSuperAccess = true;
    }
    this.homeService.isOpen = true;
  }

  ngOnInit() {

    this.activatedRoute.url.subscribe(() => {
      this.identifyReport();
    });
    this.fixedMin = new Date(2020, 1, 4);
    this.initTypes();
    this.export = '';
    let today = new Date();
    let min = this.sidePanel.isDemoUserWithSuperAccess ? new Date(this.lastDay(365)) :new Date(this.lastDay(7));
    this.minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());
    this.todayDate = new Date(today.getFullYear(), (today.getMonth()), today.getDate());
    this.activatedRoute.params.subscribe((studyID) => { 
      this.studyId = studyID.id;
      // Initialize side drawer and load visibility with caching
      this.sidePanel.initSideDrawer(localStorage.getItem('studyTYPE'));
      this.sidePanel.getVisibility(this.studyId);
    });
    if(this.sidePanel.isDemoUserWithSuperAccess){
      this.startDate = today
      this.twoYearAgo = new Date(this.startDate);
      this.twoYearAgo.setFullYear(today.getFullYear() -2);
      this.startDate = this.twoYearAgo;
    }else{
      this.startDate = this.selectedType != 'tf' ? (this.fixedMin > min ? this.fixedMin : this.minDate) : '';
    }
    this.endDate = this.selectedType != 'tf' ? this.todayDate : '';
    if (this.selectedType == 'qwf') {
      this.getDefaultDates();
    }else{
      this.getFunnelReport();
    }

    // const cookieFilter = JSON.parse((this.cookieService.check('filters') ? this.cookieService.get('filters') : '[]'));
    // if (cookieFilter && cookieFilter.length > 0) {
    //   this.selectedFilter = cookieFilter;
    // } else {
    //   if(this.selectedType == 'qwf'){
    //     this.selectedFilter = ['Age', 'City', 'UTM', 'Date'];
    //   }else{
    //     this.selectedFilter = ['Date'];
    //   }
    // }
  }
  getDefaultDates(){
    this.funnelService.getFunnelReportFilterDate({studyId: this.studyId}).subscribe((result) => {
      if (result['status'] == 1) {
        this.isLoading = false;
        this.startDate = result['start_date'];
        this.endDate = result['end_date'];
        // console.log("Start Date ====>",result['start_date'])
        // console.log("Start Date by new date  ====>",new Date(result['start_date']))
        // console.log("End Date by new date  ====>",new Date(result['end_date	']))
        // console.log("Formetted end Date ====>", this.endDate ? this.formateSql(this.endDate, 'end') : this.dateCheck('end'))
        this.getFunnelReport();
      } else {
        this.isLoading = false;
        this.notifier.notify('error', 'Something went wrong');
      }
    },
      error => {
        this.isLoading = false;
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.notifier.notify('error', 'Something went wrong');
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.notifier.notify('error', 'Something went wrong');
        }
        this.export = '';
      });
    
  }
  identifyReport() {
    if(this.router.url.indexOf('funnel-report') > -1){
      this.reportCaption = 'Funnel';
      this.selectedType = 'qwf';
    }
    if(this.router.url.indexOf('term-report') > -1){
      this.reportCaption = 'Term';
      this.selectedType = 'tf';
    }
    if(this.router.url.indexOf('utm-report') > -1){
      this.reportCaption = 'UTM';
      this.selectedType = 'uf';
    }
    if(this.router.url.indexOf('summary-report') > -1){
      this.reportCaption = 'Summary';
      this.selectedType = 'sf';
    }
  }

  lastDay(days): number {
    let d = new Date();
    let ts = d.getTime();
    let pastDays = ts - (days * 24 * 60 * 60 * 1000);
    return pastDays;
  }

  calcDate(days, date: string): number {
    let d = new Date(date);
    let ts = d.getTime();
    let pastDays = ts - (days * 24 * 60 * 60 * 1000);
    return pastDays;
  }

  initTypes() {
    this.reportType = [
      { name: 'QUESTION WISE', type: 1, key: 'qwf' },
      { name: 'DAY WISE', type: 2, key: 'dwf' },
      { name: 'HOUR WISE', type: 3, key: 'hwf' },
      { name: 'UTM WISE', type: 4, key: 'uf' },
      { name: 'CITY WISE', type: 5, key: 'cf' },
      { name: 'TERM WISE', type: 6, key: 'tf' }
    ];
  }

  getFunnelReport() {
    this.isLoading = true;
    let filter = {};
    if (this.age['from'] && this.age['to']) {
      filter['age'] = this.age;
    }
    if (this.gender.length > 0) {
      filter['gender'] = this.gender;
    }
    if (this.sec.length > 0) {
      filter['sec'] = this.sec;
    }
    if (this.quota.length > 0) {
      filter['quota'] = this.quota;
    }
    if (this.city.length > 0) {
      filter['city'] = this.city;
    }
    if (this.utm.length > 0) {
      filter['utm'] = this.utm;
    }
    if(this.selectedType == 'tf'){
      if(this.startDate && this.endDate){
        filter['dataRange'] = {
          start: this.startDate ? this.formateSql(this.startDate, 'start') : this.dateCheck('start'),
          end: this.endDate ? this.formateSql(this.endDate, 'end') : this.dateCheck('end'),
        }
      }
    }else{
      filter['dataRange'] = {
        start: this.startDate ? this.formateSql(this.startDate, 'start') : this.dateCheck('start'),
        end: this.endDate ? this.formateSql(this.endDate, 'end') : this.dateCheck('end'),
      }
    }
    const data = {
      studyId: this.studyId,
      report_type: this.selectedType,
      filter: JSON.stringify(filter)
    };

    if (this.export == 'csv') {
      data['export'] = this.export;
    }

    if(this.selectedType == 'uf'){
      if (this.groupBy == "") {
        this.groupBy = "utm_source";
        data['group'] = this.groupBy;
      }else if (this.groupBy == "NA") {
        data['group'] = "";
      }else{
        data['group'] = this.groupBy;
      }
      // data['group'] = this.groupBy;
    }
    this.funnelService.getFunnelReport(data).subscribe((result) => {
      if (result['status'] == 1) {
        if(result['allowed_filter']){
          this.allowedFilter = result['allowed_filter'];
          this.checkAllowedFilter(1);
          if(this.selectedFilter.length == 0){
              this.onSelectFilter('All');
          }
        }
        if(result['group']){
          this.groups = result['group'];
          if(this.groupBy == ''){
            this.groupBy = this.groups[0];
          }
        }
        if (result['report']) {
          this.funnelReport = result;
          this.reportListFilter = this.funnelReport['report'];
          this.isData = this.funnelReport['report'].length > 0 ? true : false;
          this.sortPositionWise(this.funnelReport['filter']['utm_filter']);
          this.sortPositionWise(this.funnelReport['filter']['quota_filter']);
          this.sortPositionWise(this.funnelReport['filter']['city_filter']);
        }
        this.isLoading = false;
        if (data['export'] == 'csv') {
          this.notifier.notify('success', "Email will be sent to you shortly");
        } else {
          if (!result['report']) {
            this.isData = false;
          }
        }
      } else {
        this.isLoading = false;
        this.isData = false;
        this.notifier.notify('error', 'Something went wrong');
      }
      this.export = "";
    },
      error => {
        this.isLoading = false;
        this.isData = false;
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.notifier.notify('error', 'Something went wrong');
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.notifier.notify('error', 'Something went wrong');
        }
        this.export = '';
      });
  }

  checkAllowedFilter(type:number){
    let filtersTemp = [];
    this.allowedFilter.forEach((key)=>{
      if(key == 'dataRange'){
        filtersTemp.push('Date');
      }
      if(key == 'age'){
        filtersTemp.push('Age');
      }
      if(key == 'gender'){
        filtersTemp.push('Gender');
      }
      if(key == 'sec'){
        filtersTemp.push('SEC');
      }
      if(key == 'utm'){
        filtersTemp.push('UTM');
      }
      if(key == 'city'){
        filtersTemp.push('City');
      }
    });
    if(type){
      this.filters = filtersTemp;
    }else{
      this.selectedFilter = filtersTemp;
    }
  }

  reportTypeSelected(type: string) {
    this.selectedType = type;
    this.getFunnelReport();
  }

  dateCheck(dateFor: string): string {
    let min: any;
    let minDate: any;

    if (dateFor == 'start') {
      if (this.endDate) {
        min = new Date(this.calcDate(7, this.endDate));
        minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());
        this.startDate = minDate;
        return this.formateSql(minDate, 'start');
      } else {
        this.startDate = minDate;
        return this.formateSql(this.todayDate, 'end');
      }
    }
    if (dateFor == 'end') {
      min = new Date(this.calcDate(-7, this.startDate));
      minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());

      let isValidDate = this.compareDate(minDate, this.todayDate);
      if (this.startDate && isValidDate) {
        min = new Date(this.calcDate(-7, this.startDate));
        minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());
        this.endDate = minDate;
        return this.formateSql(minDate, 'start');
      } else {

        return this.formateSql(this.todayDate, 'end');
      }
    }
    return '';
  }

  applyChanges() {
    this.isAction = true;
    let start = new Date(this.startDate);
    let end = new Date(this.endDate);
    let today = new Date();
    this.getFunnelReport();
  }

  exportReport() {
    let start = new Date(this.startDate);
    let end = new Date(this.endDate);
    let today = new Date();
    this.export = 'csv';
    if ((this.startDate || this.endDate) && (start > today || end > today)) {
      this.notifier.notify('error', 'Invalid Date.');
      return;
    }
    if ((this.startDate && this.endDate) && (start > end)) {
      this.notifier.notify('error', 'Start date is greater than end date.');
      return;
    }
    if (!this.isLoading) {
      // this.getFunnelReport();
      if (this.reportListFilter.length > 0) {
        this.excelService.exportAsExcelFile(this.reportListFilter, 'funnel-report-list');
      } else {
        this.notifier.notify('error', 'No data to export csv');
      }
    } else {
      this.notifier.notify('info', 'Try again after loading current process.');
    }
  }

  styleTrust(data: any): any {
    let count = 0;
    let countPCT = 0;
    let fregmentUnit = '1fr';
    data.forEach((key) => {
      const keyCheck = key.split('_')[1];
      if (keyCheck && keyCheck == 'pct') {
        countPCT++;
      }
      count++;
    });
    if (this.selectedType == 'qwf') {
      count--;
      fregmentUnit = '1fr'
    }else if(this.selectedType == 'uf'){
      fregmentUnit = '1fr'
    } else {
      fregmentUnit = '100px'
    }
    return this.sanitization.bypassSecurityTrustStyle('repeat(' + (count - countPCT) + ', ' + fregmentUnit + ')');
  }

  getRowColor(data: string, dataCount: string): string {
    let color: string = '';
    if (data && this.selectedType == 'qwf') {
      const terminated_pct = parseInt(data.split('%')[0]);
      const count = parseInt(dataCount);
      if (count >= 10) {
        if (terminated_pct >= 20 && terminated_pct < 40) {
          color = '#fff2bf';
        } else if (terminated_pct >= 40 && terminated_pct < 60) {
          color = '#FFD597';
        } else if (terminated_pct >= 60) {
          color = '#FFAFAF';
        } else {
          color = '';
        }
      }
    }
    return color;
  }

  getRowBoderColor(data: string, dataCount: string): string {
    let color: string = '';
    if (data && this.selectedType == 'qwf') {
      const terminated_pct = parseInt(data.split('%')[0]);
      const count = parseInt(dataCount);
      if (count >= 10) {
        if (terminated_pct >= 20 && terminated_pct < 40) {
          color = '1px solid #FFE78B ';
        } else if (terminated_pct >= 40 && terminated_pct < 60) {
          color = '1px solid #f7ad40';
        } else if (terminated_pct >= 60) {
          color = '1px solid #fe7a7a';
        } else {
          color = '';
        }
      }
    }
    return color;
  }

  removeTags(question: any): string {
    if (typeof question == 'string') {
      return (((question.replace(/<[^>]*>/g, '')).replace('{{', ' ')).replace('}}', ' ')).replace(/_/g, ' ');
    }
    return question ? (question + '') : '';
  }

  dataLength(question: any, len: number): string {
    if (typeof question == 'string') {
      return (question.length > len ? question.slice(0, (len - 3)) + '...' : question);
    }
    return question ? (question + '') : '';
  }

  formateSql(date: any, type: string): string {
    if (date) {
      let today = new Date(date);
      date = today.getFullYear() + '-' + this.digitFormate(today.getMonth() + 1) + '-' + this.digitFormate(today.getDate()) + (type == 'end' ? ' 23:59:59' : ' 00:00:00');
    }
    return date;
  }

  digitFormate(data: any): string {
    return data.toString().length < 2 ? '0' + data.toString() : data.toString();
  }

  addEvent(type, event) {
    if (type = 'start') {
      this.startDate = event.value;
    }

    if (type = 'end') {
      this.endDate = event.value;
    }
  }

  minContainerHeight() {
    let minHeight = '';
    if (this.selectedType == 'qwf') {
      minHeight = this.selectedFilter.length > 0 ? 'calc(100vh - 200px)' : 'calc(100vh - 164px)';
    } else {
      minHeight = this.selectedFilter.length > 0 ? 'calc(100vh - 184px)' : 'calc(100vh - 150px)';
    }
    return this.sanitization.bypassSecurityTrustStyle(minHeight);
  }

  clickEnabled(obj: any) {
    obj.opened = true;
    if (obj.id == "mat-datepicker-0") {
      this.endDate = this.todayDate;
    }
  }

  selectAll(obj: string, checkItem: any) {
    checkItem.checked = !checkItem.checked;
    if (obj == 'quota' && checkItem.checked == true) {
      this.quota = [];
    }
    if (obj == 'utm' && checkItem.checked == true) {
      this.utm = [];
    }
    if (obj == 'city' && checkItem.checked == true) {
      this.city = [];
    }
  }

  sortPositionWise(sortArrayObj) {
    sortArrayObj.sort(function (firstEl, secEl) {
      let firstKey = firstEl.key.toLowerCase();
      let secKey = secEl.key.toLowerCase();
      if (firstKey < secKey) { return -1; }
      if (firstKey > secKey) { return 1; }
      return 0;
    });
  }

  compareDate(date: string, date2: string): boolean {
    const d1 = new Date(date);
    const d2 = new Date(date2);
    if (d1 >= d2) {
      return false;
    } else {
      return true;
    }
  }

  concatData(row: any, key: string): string {
    let concatData: string = '';
    if (row) {
      if (key == 'started_pct') {
        concatData = row['started'] + ' (' + row[key] + ')';
      } else if (key == 'drop_pct') {
        concatData = row['drop'] + ' (' + row[key] + ')';
      } else if (key == 'terminated_pct') {
        concatData = row['terminated'] + ' (' + row[key] + ')';
      } else if (key == 'completed_pct') {
        concatData = row['completed'] + ' (' + row[key] + ')';
      } else if (key == 'overquota_pct') {
        concatData = row['over_quota'] + ' (' + row[key] + ')';
      } else if (key == 'answered_pct') {
        concatData = row['answered'] + ' (' + row[key] + ')';
      } else if (key == 'flagged_pct') {
        concatData = row['flagged'] + ' (' + row[key] + ')';
      } else if (key == 'race_condition_pct') {
        concatData = row['race_condition'] + ' (' + row[key] + ')';
      } else {
        concatData = row[key];
      }
    }
    return concatData;
  }

  displayKey(key: string): boolean {
    let status: boolean = false;
    if (this.selectedType == 'qwf' ||this.selectedType == 'uf') {
      if (key == 'postquality' || key == 'started' || key == 'drop' || key == 'terminated' || key == 'completed' || key == 'answered' || key == 'flagged' || key == 'over_quota' || key == 'race_condition') {
        status = true;
      }
    }
    return status;
  }

  formateKey(key: string): string {
    let status: string = key;
    if (this.selectedType == 'qwf' || this.selectedType == 'uf') {
      if (key == 'postquality_pct' || key == 'started_pct' || key == 'drop_pct' || key == 'answered_pct' || key == 'flagged_pct' || key == 'terminated_pct' || key == 'race_condition_pct' || key == 'overquota_pct' || key == 'completed_pct') {
        status = key.split('_')[0] + ' (%)';
      }
    }
    return status;
  }

  onSelectFilter(filter: string) {
    setTimeout(() => {
      const index = this.selectedFilter.indexOf(filter);
      if (filter == 'All') {
        if (this.selectedFilter.length != this.allowedFilter.length) {
          this.checkAllowedFilter(0);
        } else {
          this.selectedFilter = [];
        }
      } else {
        if (index == -1) {
          this.selectedFilter.push(filter);
        } else {
          this.selectedFilter.splice(index, 1);
        }
      }
      this.cookieService.set('filters', JSON.stringify(this.selectedFilter));
    });
  }

  resetChanges() {
    this.isAction = false;
    this.sec = [];
    this.city = [];
    this.utm = [];
    this.gender = [];
    this.age = { from: null, to: null };
    if(this.sidePanel.isDemoUserWithSuperAccess){
      this.startDate = this.twoYearAgo;
    }else{
      if(this.selectedType == 'tf'){
        this.startDate = '';
        this.endDate = '';
      }
    }
    this.getFunnelReport();
  }

  switchMoreFilter() {
    this.isFilter = false;
    this.isMoreFilter = !this.isMoreFilter;
  }

  openTeriminited(row: any, key: string) {
    if (this.selectedType == 'qwf' && (key == 'terminated_pct' && row['terminated'] > 0)) {

      let filter = {};
      if (this.age['from'] && this.age['to']) {
        filter['age'] = this.age;
      }
      if (this.gender.length > 0) {
        filter['gender'] = this.gender;
      }
      if (this.sec.length > 0) {
        filter['sec'] = this.sec;
      }
      if (this.quota.length > 0) {
        filter['quota'] = this.quota;
      }
      if (this.city.length > 0) {
        filter['city'] = this.city;
      }
      if (this.utm.length > 0) {
        filter['utm'] = this.utm;
      }
      filter['dataRange'] = {
        start: this.startDate ? this.formateSql(this.startDate, 'start') : this.dateCheck('start'),
        end: this.endDate ? this.formateSql(this.endDate, 'end') : this.dateCheck('end'),
      }

      this.dialogService.isData = 'terminated';
      this.dialogService.studyId = this.studyId;
      const TerminatedData = { row: row, key: key, filter: filter };
      this.openDialog(TerminatedData);
    }
  }

  openDialog(TerminatedData: any): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '60vw',
      height: '75vh',
      data: TerminatedData
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onBlurFilter() {
    setTimeout(() => {
      this.isMoreFilter = false;
    }, 400);
  }

  sortHead(sortBy: string) {
    this.isSortBy = ((this.sortBy != sortBy && this.sortBy != '') ? true : !this.isSortBy);
    this.sortBy = sortBy;
    this.sortByHead(this.reportListFilter, sortBy);
  }

  sortByHead(unSortedArry: any, soryBy: string) {
    soryBy = soryBy.split('_pct')[0];
    // if(soryBy == 'race'){soryBy = 'race_condition'}
    if(soryBy == 'overquota'){soryBy = 'over_quota'}
    unSortedArry.sort((obj1, obj2) => {
      if (obj1[soryBy] > obj2[soryBy]) {
        return (this.isSortBy ? 1 : -1);
      }
      if (obj1[soryBy] < obj2[soryBy]) {
        return (this.isSortBy ? -1 : 1);
      }
      return 0;
    });
  }

  selectDateChange(event) {
    setTimeout(() => {
      // debugger;
      const date = new Date(event);
      this.startDate = new Date(date.getDate(), (date.getMonth()), date.getFullYear());
    });
  }

  // shiftBlank(arrayToShift:any):any{
  //   const isElem = arrayToShift.indexOf('BLANK');
  //   if(isElem > 0){
  //     arrayToShift.splice(isElem, 1);
  //     arrayToShift.unshift('BLANK');
  //   }
  //   return arrayToShift;
  // }

  switchGroup(group: string) {
    this.isFilter = !this.isFilter;
    if (group != 'default') {
      this.groupBy = group;
    } else {
      this.groupBy = undefined;
    }
    this.getFunnelReport();
  }
  onUnGroup(){
    this.groupBy = "NA"; 
    this.getFunnelReport();
  }

  onBlurGroup() {
    setTimeout(() => {
      this.isFilter = false;
    }, 400);
  }

  switchFilter() {
    this.isMoreFilter = false;
    this.isFilter = !this.isFilter;
  }

}
